export const DiceGameName = "Dice Game"
export const RiskDuelName = "Risk Duel"